import { Storage } from 'aws-amplify';
import { S3ObjectInput } from '@sdk/API';

import AWS_CONFIG from '@sdk/aws-exports';

type StorageObject = {
  key: string;
  bucket?: string;
  region?: string;
};

export const getImageUrl = async ({
  key,
  bucket = AWS_CONFIG.aws_user_files_s3_bucket,
  region = AWS_CONFIG.aws_user_files_s3_bucket_region,
}: StorageObject): Promise<string> => {
  const url = (await Storage.get(key, {
    bucket,
    region,
  })) as string;
  return url;
};

export const uploadImage = async (
  file: File,
  key: string,
  progressCallback?: (progress: ProgressEvent) => void
): Promise<S3ObjectInput> => {
  const extension = file.name.split('.').pop();
  const filename = `${key || file.name}.${extension}`;

  const config: any = {};
  if (progressCallback) config.progressCallback = progressCallback;

  await Storage.put(filename, file, config);

  return {
    bucket: AWS_CONFIG.aws_user_files_s3_bucket,
    region: AWS_CONFIG.aws_user_files_s3_bucket_region,
    key: filename,
  };
};
